import React from 'react';
import { motion } from 'framer-motion';
import useT from '../../../i18n';

/**
 * Om Norge-teaser — image + text pair leading to /om-norge.
 * Uses the same Kristiansand photo as the /om-norge page for visual echo.
 */
export default function AboutNorway({ onNavigate }) {
  const t = useT();
  const s = t.landingV2.norway;

  return (
    <section
      className="bg-paper py-section border-t border-ink/[0.06]"
      data-testid="landing-norway"
    >
      <div className="max-w-editorial mx-auto px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16 items-center"
        >
          <div className="md:col-span-7">
            <picture>
              <source srcSet="/assets/hero/kristiansand-hero.webp" type="image/webp" />
              <img
                src="/assets/hero/kristiansand-hero.png"
                alt="Kristiansand — Norvig HQ"
                className="w-full aspect-[4/3] object-cover"
                loading="lazy"
                decoding="async"
                data-testid="norway-image"
              />
            </picture>
          </div>

          <div className="md:col-span-5">
            <p className="font-sans text-xs uppercase tracking-widest text-ink/50">
              {s.eyebrow}
            </p>
            <h2 className="mt-6 font-display font-light text-display-md text-ink whitespace-pre-line">
              {s.title}
            </h2>
            <p className="mt-6 font-sans text-base text-ink/70 leading-relaxed">
              {s.body}
            </p>
            <button
              onClick={() => onNavigate?.('/om-norge')}
              className="mt-8 inline-flex items-center gap-2 font-sans text-sm text-ink/70 hover:text-ink underline underline-offset-8 decoration-ink/20 hover:decoration-ink/40 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-fjord/40 focus-visible:ring-offset-4 focus-visible:ring-offset-paper rounded-sm"
              data-testid="norway-cta"
            >
              {s.cta} <span aria-hidden>→</span>
            </button>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
